var shiftWindow = () => { scrollBy(0, -50) };
window.addEventListener("hashchange", shiftWindow);
function load() { if (window.location.hash) shiftWindow(); }

$(document).ready(() => {
	load();
});

window.onhashchange = shiftWindow;